import { useRef } from 'react';

import { useGetPolicy } from '@/hooks/queries/external';
import { useConvertPolicy } from '@/hooks/useConvertPolicy';

const PolicyTemplate = ({ routeKey }: { routeKey: string }) => {
  const query = useGetPolicy(routeKey);
  const el = useRef<HTMLElement>(null);

  useConvertPolicy({
    el,
    query,
  });

  return (
    <section
      ref={el}
      dangerouslySetInnerHTML={{
        __html: query.data || '',
      }}
    />
  );
};

export default PolicyTemplate;
